import { DMSv3MonitoringFilters, DMSv3MonitoringTable } from "modules/DMSv3/Monitoring/components";
import "modules/DMSv3/Monitoring/Monitoring.scss";

export const Monitoring = () => {
  return (
    <div className="DMSv3Monitoring">
      <DMSv3MonitoringFilters />
      <DMSv3MonitoringTable />
    </div>
  );
};
